const dev = {
    API_ENDPOINT_URL: 'https://localhost:5001/',
    LOCATION_API_URL: 'https://www.associatedasset.com/wp-json/location/',
    HUB_API_ENDPOINT_URL: 'https://aamallaccesshubapi.azurewebsites.net/',
    REACT_APP : "http://localhost:3000/",
    PAYA_DEVELOPER_ID: '0703a81c',
    PAYA_HASH_KEY: 'a2bfc11b-616f-4692-b814-c0b988b0f577',
    PAYA_USER_ID: '11efabfd41d6322ab1d35a10',
    PAYA_LOCATION_ID: '11efabfd3a8ee0e8aa0edb8c',
    PAYA_CC_PRODUCT_TRANSACTION_ID: '11efabfd3b651c44b92d3b2b',
    PAYA_ACH_PRODUCT_TRANSACTION_ID: '11efabfd3f4a3d089d586066',
    PAYA_BASE_URL: 'https://api.sandbox.payaconnect.com'
  };
  const prod = {
    API_ENDPOINT_URL: 'https://mobileweb.associatedasset.com/',
    LOCATION_API_URL: 'https://www.associatedasset.com/wp-json/location/',
    HUB_API_ENDPOINT_URL: 'https://aamallaccesshubapi.azurewebsites.net/',
    REACT_APP : "https://brave-flower-0605bd81e.5.azurestaticapps.net/",
    PAYA_DEVELOPER_ID: '9c4dc25d',
    PAYA_HASH_KEY: '4a5fc771697cac0374e8acdc',
    PAYA_USER_ID: '11ef49012f5d17b2b8f1671a',
    PAYA_LOCATION_ID: '11ef48613e7dfe8c892d1f0e',
    PAYA_CC_PRODUCT_TRANSACTION_ID: '11ef490259b6109e98430f98',
    PAYA_ACH_PRODUCT_TRANSACTION_ID: '11effdc4b9927ae4b6814d25',
    PAYA_BASE_URL: 'https://api.payaconnect.com'
  };  
  const test = {
    API_ENDPOINT_URL: 'https://testmobileweb.associatedasset.com/',
    HUB_API_ENDPOINT_URL: 'https://devallaccesshub.azurewebsites.net/',
    REACT_APP: "https://yellow-plant-07a72c61e.4.azurestaticapps.net/",
    PAYA_DEVELOPER_ID: '0703a81c',
    PAYA_HASH_KEY: 'a2bfc11b-616f-4692-b814-c0b988b0f577',
    PAYA_USER_ID: '11efabfd41d6322ab1d35a10',
    PAYA_LOCATION_ID: '11efabfd3a8ee0e8aa0edb8c',
    PAYA_CC_PRODUCT_TRANSACTION_ID: '11efabfd3b651c44b92d3b2b',
    PAYA_ACH_PRODUCT_TRANSACTION_ID: '11efabfd3f4a3d089d586066',
    PAYA_BASE_URL: 'https://api.sandbox.payaconnect.com'
  };
  
  const getEnv = () => {
      switch (process.env.NODE_ENV) {
          case 'development':
              return dev
          case 'production':
              return prod
          case 'test':
              return test
          default:
              break;
      }
  }
  
  export const env = getEnv()
  